import React, { FC, HTMLAttributes } from 'react';

import { SpacingProps, spacing } from '@material-ui/system';
import styled from 'styled-components';

import { Loader as NordLoader } from '@nord/ui';

export interface ILoader extends SpacingProps, HTMLAttributes<HTMLDivElement> {
  centered?: boolean;
}

const StyledLoader = styled(NordLoader)`
  color: #4687ff;

  ${({ $centered }) =>
    $centered &&
    `
    position: fixed;
    top: 50%;
    left: 50%;
     transform: translate(-50%, -50%);
  `}

  ${spacing}
`;

/**
 *
 * @deprecated use @nordvpn/teams.ui/lib/foundation/atoms/Loader
 */
export const Loader: FC<ILoader> = ({ centered, ...rest }) => (
  <StyledLoader size="small" data-testid="loader" $centered={centered} {...rest} />
);
